import Activity from './models/ActivityModel'
import Calendar from './models/CalendarModel'
import Company from './models/CompanyModel'
import Department from './models/DepartmentModel'
import Employee from './models/EmployeeModel'
import MonthlyWorkday from './models/MonthlyWorkdayModel'
import PartnerCustomerEmployee from './models/PartnerCustomerEmployeeModel'
import ProcedureRequest from './models/ProcedureRequest'
import ProjectEmployee from './models/ProjectEmployeeModel'
import Project from './models/ProjectModel'
import TrainingAction from './models/TrainingActionModel'
import TrainingBudget from './models/TrainingBudgetModel'
import TrainingEnrollment from './models/TrainingEnrollmentModel'
import Vacation from './models/VacationModel'
import Workday from './models/WorkdayModel'
import WorkPlace from './models/WorkPlaceModel'

export default {
    tables: [
        {
            name: "wkt.admin.qbuilder.qbmodel.customers",//'Clientes',
            entity: 'FullCompany',
            roles: ['moduleCustomers', 'modulePartnerCustomers']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.checkin_detail",//'Check-in - detalle actividades',
            entity: 'FullActivity',
            roles: ['moduleDaily', 'moduleMonthly', 'moduleEmployee']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.checkin_diary_summary",//'Check-in - resumen diario',
            entity: 'FullWorkdayDailyStats',
            roles: ['moduleDaily', 'moduleMonthly', 'moduleEmployee']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.checkin_monthly_summary",//'Check-in - resumen mensual',
            entity: 'FullWorkdayMonthlyStats',
            roles: ['moduleDaily', 'moduleMonthly', 'moduleEmployee']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.project_definition",//'Proyectos - definición',
            entity: 'Project',
            roles: ['moduleProjects']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.project_team",//'Proyectos - equipo de trabajo',
            entity: 'FullProjectEmployee',
            roles: ['moduleProjects']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.project_activity_registry",//'Proyectos - Registro de actividades',
            entity: 'FullActivityProjectRegistry',
            roles: ['moduleProjects']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.holiday_registry",//'Registro de ausencias',
            entity: 'FullVacation',
            roles: ['moduleHolidays']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.requests",//'Solicitudes',
            entity: 'QBFullProcedureRequest',
            roles: ['moduleProcedures']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.employees",//'Trabajadores',
            entity: 'QBFullEmployee',
            roles: ['moduleStaff']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.training_actions",//'Formación - acciones',
            entity: 'QBFullTrainingAction',
            roles: ['moduleTraining']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.training_enrollments",//'Formación - inscripciones',
            entity: 'QBFullTrainingEnrollment',
            roles: ['moduleTraining']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.training_budgets",//'Formación - presupuestos',
            entity: 'QBFullTrainingBudget',
            roles: ['moduleTrainingBudget']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.departments",//'Departamentos',
            entity: 'Department',
            roles: ['moduleDepartments']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.work_places",//'Centros de trabajo',
            entity: 'WorkPlace',
            roles: ['moduleWorkplace']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.calendars",//'Calendarios',
            entity: 'Calendar',
            roles: ['moduleCalendar']
        },
        {
            name: "wkt.admin.qbuilder.qbmodel.partner_customer_employees",//'Mis clientes-trabajadores',
            entity: 'QBFullPartnerCustomerEmployee',
            roles: ['modulePartnerCustomers']
        },
    ],
    columns: {
        'QBFullEmployee': Employee.columns,
        'FullWorkdayDailyStats': Workday.columns,
        'FullWorkdayMonthlyStats': MonthlyWorkday.columns,
        'FullActivity': Activity.columns,
        'FullActivityProjectRegistry': Activity.columns,
        'FullVacation': Vacation.columns,
        'FullProjectEmployee': ProjectEmployee.columns,
        'Project': Project.columns,
        'FullCompany': Company.columns,
        'QBFullProcedureRequest': ProcedureRequest.columns,
        'QBFullTrainingAction': TrainingAction.columns,
        'QBFullTrainingEnrollment': TrainingEnrollment.columns,
        'QBFullTrainingBudget': TrainingBudget.columns,
        'Department': Department.columns,
        'WorkPlace': WorkPlace.columns,
        'Calendar': Calendar.columns,
        'QBFullPartnerCustomerEmployee': PartnerCustomerEmployee.columns,
    },
}
